<template>
    <div class="items" :class="{'itemsOpcity': stop || !effectData.isBuy}">
        <div class="item-left">
            <input class="doRadio" @click="onAddOrder" type="checkbox" :checked="effectData.exprieCheck" :value="effectData.couponDetailId" name="sex" :disabled='!effectData.isBuy'>
            <label></label>
        </div>
        <div class="itemLeft f64">
            <span class="f36">¥</span>{{ effectData.couponValue }}
        </div>
        <div class="itemRight" :class="{'effectImg': effectData.stackable}">
            <div class="title">
                <h3 class="f28 col000" v-text="effectData.couponName"></h3>
                <p class="f24 col666" v-show="effectData.couponType !== 2">满{{ effectData.reachAmount }}元使用</p>
            </div>
            <div class="time col666">{{ effectData.effectiveStartDate | formatDate3 }}-{{ effectData.effectiveEndDate | formatDate3 }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        effectData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        stop: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onAddOrder () {
            this.$emit('onAddOrder')
        }
    }
}
</script>

<style lang="scss" scoped>
    .items{
        border-radius: 12px;
        margin-top: 20px;
        height: 192px;
        display: flex;
        justify-content: flex-start;
        .item-left{
            display: flex;
            align-items: center;
            margin-right: 10px;
            input{
                position: absolute;
                margin: 0;
            }
        }
        h3{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
        }
        .itemLeft{
            width: 224px;
            line-height: 192px;
            text-align: center;
            background: url(../../../../assets/img/b2b/coupon.png) no-repeat;
            background-size: 100% 100%;
            font-family:SFUIDisplay-Bold;
            font-weight:bold;
            color:rgba(255,255,255,1);
            &.couponCopy{
                background: url(../../../../assets/img/b2b/couponCopy.png) no-repeat;
                background-size: 100% 100%;
            }
        }
        .itemRight{
            flex: 1;
            padding: 32px 0 0 20px;
            background: rgba(255,255,255,1);
            border-top-right-radius: 12px;
            border-bottom-right-radius: 12px;
            position: relative;
            .title{
                height: 80px;
                p{
                    margin-top: 8px;
                }
            }
            .time{
                font-family:PingFangSC-Regular;
                font-size: 22px;
                margin-top: 26px;
                white-space: nowrap;
                transform: scale(0.95);
                transform-origin: 0 0 0;
            }
            &.effectImg::before{
                content: '';
                position: absolute;
                right: 20px;
                width: 136px;
                height: 136px;
                background: url(../../../../assets/img/b2b/isSelect.png) no-repeat;
                background-size: 100% 100%;
            }
        }
        &.itemsOpcity{
            opacity: 0.7;
        }
    }
</style>